var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-notifications_svg__cls-7{fill:none}.kpmg-notifications_svg__cls-6{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications_svg__ICN_FAlerte_Notificari_pe_e-mail_Enabled",
    "data-name": "ICN_FAlerte/Notificari pe e-mail_Enabled",
    transform: "translate(-100 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-notifications_svg__Polygon_9",
    "data-name": "Polygon 9",
    d: "M21.679 0a4 4 0 013.473 2.015l5.714 10a4 4 0 010 3.969l-5.714 10A4 4 0 0121.679 28H10.321a4 4 0 01-3.473-2.015l-5.714-10a4 4 0 010-3.969l5.714-10A4 4 0 0110.321 0z",
    transform: "translate(100 232)",
    fill: "#004a9b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications_svg__Group_1493",
    "data-name": "Group 1493",
    transform: "translate(66 51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications_svg__Group_1487",
    "data-name": "Group 1487",
    transform: "translate(-67 3.129)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications_svg__Rectangle_440",
    "data-name": "Rectangle 440",
    transform: "translate(109 189)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-notifications_svg__cls-6",
    width: 13.716,
    height: 10.488,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-notifications_svg__cls-7",
    x: 0.8,
    y: 0.8,
    width: 12.116,
    height: 8.888,
    rx: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications_svg__Polygon_6",
    "data-name": "Polygon 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-notifications_svg__cls-6",
    d: "M6.172.645a1 1 0 011.371 0l4.336 4.081a1 1 0 01-.685 1.728H2.522a1 1 0 01-.685-1.728z",
    transform: "rotate(180 61.358 97.727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.858 2.197L4.035 4.854H9.68L6.858 2.197m0-1.824c.246 0 .493.09.685.272l4.336 4.081c.66.62.22 1.728-.685 1.728H2.522c-.906 0-1.345-1.107-.686-1.728L6.172.646a.997.997 0 01.686-.273z",
    fill: "#fff",
    transform: "rotate(180 61.358 97.727)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications_svg__Ellipse_203",
    "data-name": "Ellipse 203",
    transform: "translate(48 185)",
    strokeWidth: 1.6,
    stroke: "#fff",
    fill: "#004a9b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-notifications_svg__cls-6",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-notifications_svg__cls-7",
    cx: 5,
    cy: 5,
    r: 4.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-notifications_svg__Path_946",
    "data-name": "Path 946",
    d: "M53.469 191.2H52.4l-.168-3.887h1.4zm-1.269 1.21a.606.606 0 01.2-.474.757.757 0 01.521-.186.757.757 0 01.521.186.606.606 0 01.214.474.606.606 0 01-.209.475.757.757 0 01-.521.185.757.757 0 01-.526-.185.606.606 0 01-.2-.475z",
    strokeWidth: 0.3,
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff"
  })))));
}

export default SvgKpmgNotifications;